import React, { lazy, Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import store from './store/index';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Progress } from './components/ui/progress'; // Import the Progress component from shadcn/ui
import { ThemeProvider } from './context/ThemeContext';

// Custom hook to track loading progress
const useLoadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleProgress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        setProgress(percentComplete);
      }
    };

    // Simulate real loading progress (for demonstration purposes)
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2; // Slower increment for 2s duration (approx 50 steps * 40ms = 2000ms)
      });
    }, 40); // Faster interval, smaller steps for smoother animation

    return () => clearInterval(interval);
  }, []);

  return progress;
};

// Lazy load the App component with a minimum delay to show the loading animation
const App = lazy(() => {
  return Promise.all([
    import('./App'),
    new Promise(resolve => setTimeout(resolve, 2000)) // Wait for 2 seconds
  ]).then(([moduleExports]) => moduleExports);
});

// Custom Loading Component
const LoadingScreen = () => {
  const progress = useLoadingProgress(); // Get the loading progress

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white space-y-4">
      {/* Progress Bar */}
      <div className="w-64">
        <Progress value={progress} className="h-2" indicatorClassName="bg-blue-600" />
      </div>
      {/* Preparing Text */}
      <p className=" text-lg font-semibold">Preparing merchant</p>
    </div>
  );
};

// Render the app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <Suspense fallback={<LoadingScreen />}>
          <App />
          <Toaster
            toastOptions={{
              position: 'top-right',
              style: {
                background: 'white',
                color: 'black',
              },
            }}
          />
        </Suspense>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();